import React from "react"
import { Link } from "gatsby"
import { Col, Card, CardBody } from "reactstrap"

// Gatsby Specific imports
import { GatsbyImage, getImage } from "gatsby-plugin-image"

//Import Icons
import FeatherIcon from "feather-icons-react"

const TeamBox = props => {
  return (
    <>
      {props.candidates.map((candidate, key) => (
        <Col lg="5" md="6" key={key} className="mt-2">
          <Card
            className={
              props.isTransparent === true
                ? "team text-center bg-transparent border-0"
                : "team text-center rounded border-0"
            }
            name="team"
            id="teambox"
          >
            <CardBody className={props.isTransparent === true ? "p-0" : ""}>
              <div className="position-relative">
                {/* <img
                  src={candidate.image}
                  className="img-fluid avatar avatar-ex-large rounded-circle shadow"
                  alt=""
                /> */}
                <GatsbyImage
                  image={getImage(candidate.image)}
                  className="img-fluid avatar avatar-ex-large rounded-circle shadow"
                  alt="Muhammad Ilyas Kpada"
                />
                <ul className="list-unstyled social-icon team-icon mb-0 mt-4">
                  {candidate.socialIds.map((id, key) => (
                    <li key={key} className="list-inline-item me-1">
                      <a href={id.link} className="rounded">
                        <i>
                          <FeatherIcon
                            icon={id.icon}
                            className="fea icon-sm fea-social"
                          />
                        </i>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={
                  props.isTransparent === true
                    ? "content pt-3 pb-3"
                    : "content pt-3"
                }
              >
                <h5 className="mb-0">
                  <Link to={candidate.link} className="name text-primary">
                    {candidate.name}
                  </Link>
                </h5>
                <small className="designation text-muted">
                  {candidate.designation}
                </small>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  )
}

export default TeamBox
